import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './content.styl'

export default class Content extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
